export default {
  AVAILABLE_FOR_OVER_AMOUNT: '满{AMOUNT}元可用',
  AVAILABLE_FOR_OVER_QUANTITY: '满{QUANTITY}件可用',
  FOREACH_QUANTITY_GET_QUANTITY_FREE: '每买{QUANTITY}件可用',
  DISCOUNT_CHEAPEST_NOF_M: '满{QUANTITY}件1件最\n低单价享受',
  ZERO_THRESHOLD_IS_AVAILABLE: '0门槛可用',
  FREE_SHIPPING_FOR_X_PIECES: '满{QUANTITY}件免邮',
  ALL_CATEGORY_BENEFITS_FOR_FULL_SELECTION: '全场全品类福利',
  ZERO_THRESHOLD_FREE_SHIPPING: '零门槛国际免邮',
  FREE_SHIPPING: '免邮',
  TAKE_IT_NOW: '立即领取',
  TO_USE: '去使用',
  REDEEMED: '可使用',
  USED: '已使用',
  EXPIRED: '已过期',
  ALREADY_SOLD_OUT: '已抢光',
  NOT_STARTED: '未开始',
  SEE_MORE: '点击查看更多',
  CLAIMED_SUCCESSFULLY: '领取成功',
  CLAIMED_FAILED: '领取失败',
  NO_COUPON: '暂无优惠券',
  UNAVAILABLE: '不可用',
  AVAILABLE_GOODS: '可用商品'
};
